export default __webpack_public_path__ + "static/9-a824948e24d4b716c22c3d51bdfe3a9b.jpg";